import { GET_SOW_NOTIFICATIONS_FAILED, GET_SOW_NOTIFICATIONS_IN_PROGRESS, GET_SOW_NOTIFICATIONS_SUCCESS } from "../../constants/store";

// The initial state
export const initialState = {
  loading: true,
  pendingCount: 0,
};

function pendingSOWNotificationReducer(state = initialState, action){
  switch (action.type) {
    // pending notifications
    case GET_SOW_NOTIFICATIONS_IN_PROGRESS: {
      const newState = {
        ...state,
        loading: true,
      };
      return newState;
    }
    case GET_SOW_NOTIFICATIONS_SUCCESS: {
      const newState = {
          ...state,
          pendingCount: action.payload.count,
          loading: false,
      };
      return newState;
    }
    case GET_SOW_NOTIFICATIONS_FAILED: {
      const newState = {
        ...state,
        loading: false,
      };
      return newState;
    }
    default:
      return state;
  }
}
export default pendingSOWNotificationReducer;
